import { ROUTES } from '@/routes/Routes';

export const getPreviewUrl = (meetingID: string, code: string) => {
  return `${window.location.origin}${ROUTES.PREVIEW_MEETING}?meeting=${meetingID}&previewCode=${code}`;
};
